"use client";

import { CommandItem, CommandShortcut } from "@layer/ui/components";
import type { CommandGroupType } from "@layer/utils/lib/commands";
import { useTranslations } from "next-intl";

type CommandBarGroupItemType = {
	commandsGroupItems: CommandGroupType[];
	handleCommand: (command: CommandGroupType) => void;
};

const CommandBarGroupItem = ({
	commandsGroupItems,
	handleCommand,
}: CommandBarGroupItemType) => {
	const t = useTranslations("Navigation.command");

	return commandsGroupItems.map((item: CommandGroupType) => {
		const { id: command, hotkey, icon } = item;
		const IconComponent = icon;

		return (
			<CommandItem
				key={command}
				keywords={hotkey ? [hotkey, hotkey.toLowerCase()] : undefined}
				onSelect={() => handleCommand(item)}
				className="flex items-center"
			>
				{IconComponent && (
					<IconComponent variant="filled" className="h-2 w-2 mr-1" />
				)}
				<span>{t(command)} </span>
				<div className="ml-auto flex items-center gap-x-1">
					{hotkey?.split("").map((k, _i) => (
						<CommandShortcut
							key={`${hotkey}-${k}`}
							className="uppercase"
						>
							{k}
						</CommandShortcut>
					))}
				</div>
			</CommandItem>
		);
	});
};

export { CommandBarGroupItem };
